import { is } from '@common/is/is'

import { getTransById } from '@common/i18n/v1/translate'

import Text from '@common/components/Text/Text'

import type Button from '../Button/Button'

import { navigator, ENavigator } from '../../navigator'
import activator, { EResponse }  from '../../activator'

import styles from './Activate.css'

class Activate extends HTMLElement {
  public connectedCallback (): void {
    this.appendChild(
      <Fragment>
        {
        // 7 napos próbakód: e0heluw722ou
        // Örökéletű próbakód: b0taux76qg5p
        }

        <div className={ styles.center }>
          <input
            name="code"
            className={ styles.input }
            placeholder={ getTransById('activator.input.placeholder') }
            type="text"
          />
        </div>

        <div className={ styles.response } />

        <a-button-container>
          <a-button action={ ENavigator.Licence } icon="back" key="activator.button.back" />
          <a-button icon="activate" key="activator.button.activate" onClick={ this.onClickActivate } />
        </a-button-container>
      </Fragment>
    )
  }

  /**
   * Aktiváló gomb megnyomásánál callback.
   * @param e - Az esemény, amit a click-re kapunk.
   */
  private readonly onClickActivate = (e: Event): void => {
    const code = (this.querySelector('[name="code"]') as HTMLInputElement).value
    const btn = e.currentTarget as Button
    btn.disabled = true

    activator.activate(code, (res?: number | string) => {
      btn.disabled = false

      const el = this.querySelector(`.${ styles.response }`) as HTMLElement
      el.innerHTML = ''

      if (res === EResponse.Invalid) {
        el.appendChild(<Text.instance key="activator.error.invalid" />)
      }
      else if (res === EResponse.AlreadyInUse) {
        el.appendChild(<Text.instance key="activator.error.already_in_use" />)
      }
      else if (is.undefined(res)) {
        navigator.congrats()
      }
      else /* if (res === SERVER_ERROR) */ {
        // Bármilyen hiba esetén mondjuk azt, hogy a serverrel van baj...
        el.appendChild(<Text.instance key="activator.error.server_error" />)
      }
    })
  }
}

customElements.define('a-activate', Activate)
